import { render, staticRenderFns } from "./CheckMark.vue?vue&type=template&id=f3d4c53a&scoped=true&"
import script from "./CheckMark.vue?vue&type=script&lang=js&"
export * from "./CheckMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d4c53a",
  null
  
)

export default component.exports